import {
  CSVFileIcon,
  DocxFileIcon,
  ExcelFileIcon,
  ImageFile,
  JpegImageIcon,
  JpgImageIcon,
  PDFIcon,
  PngImageIcon,
  TxtFileIcon,
  XlsFileIcon,
} from '@commenda/icons';

export const fileIconMap: { [key: string]: React.ElementType } = {
  '.pdf': PDFIcon,
  '.xlsx': ExcelFileIcon,
  '.xls': XlsFileIcon,
  '.png': PngImageIcon,
  '.jpg': JpgImageIcon,
  '.jpeg': JpegImageIcon,
  '.csv': CSVFileIcon,
  '.txt': TxtFileIcon,
  '.img': ImageFile,
  '.docx': DocxFileIcon,
};
